class OfficesController {
  constructor(OfficesService, $window, NgMap, MapsApiKey, $state) {
    'ngInject';
    Object.assign(this, {NgMap, MapsApiKey, $state});
    OfficesService.list().then((offices) => this.offices = offices);
    // show map iff on big screens
    this.showMap = $window.innerWidth >= 768;
  }

  selectOffice(office) {
    console.debug(office);
    this.$state.go('offices.office', {officeId: office.id})
      .then(() => {
        if (this.showMap) {
          this.panToOffice(office);
        }
      });
  }

  /**
   * Record user coordinates after geolocation
   */
  setUserCoords() {
    this.NgMap.getMap().then((map) => this.userCoords = map.getCenter());
  }

  panToOffice(office) {
    console.debug('Office:', office.recapito);
    let coords = null;
    // function to pan map
    let panMap = (map) => {
      console.debug('Moving to', coords);
      map.panTo(coords);
      this.officeMarker = {coords: [coords.lat, coords.lng]};
      // record distance to office
      if (this.userCoords) {
        this.officeMarker.distance = OfficesController
          .getDistance(coords.lat, coords.lng, this.userCoords.lat(), this.userCoords.lng());
      }
    };
    if (coords = OfficesController._getCoordinates(office)) {
      this.NgMap.getMap().then(panMap);
    } else {
      // use geocoding to find office
      let fullAddress = `${office.recapito.indirizzo} - ${office.recapito.cap}, ${office.recapito.comune}`;
      this.NgMap.getGeoLocation(fullAddress)
        .then((point) => {
          console.log('Located at', point.lat(), point.lng());
          coords = {lat: point.lat(), lng: point.lng()};
          this.NgMap.getMap().then(panMap);
        });
    }
  }

  getAddressURL(location) {
    let fullAddress = location.indirizzo + ', ' + location.comune;
    return `http://maps.google.com?q=${encodeURI(fullAddress)}`;
  }

  static getDistance(lat1, lon1, lat2, lon2) {
    if (typeof lat1 == "string") lat1 = parseFloat(lat1);
    if (typeof lat2 == "string") lat2 = parseFloat(lat2);
    if (typeof lon1 == "string") lon1 = parseFloat(lon1);
    if (typeof lon2 == "string") lon2 = parseFloat(lon2);
    let toRad = function (arg) {
      return arg * Math.PI / 180;
    };
    var R = 6371; // km
    var dLat = toRad(lat2 - lat1);
    var dLon = toRad(lon2 - lon1);
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }


  static _getCoordinates(office) {
    try {
      // since coords is not valid JSON object add quotes to it to make it working
      return JSON.parse(office.recapito.coords.replace('lat', '"lat"').replace('lng', '"lng"'));
    } catch (e) {
      return null;
    }
  }
}

export default OfficesController;



// WEBPACK FOOTER //
// ./client/app/components/offices/offices.controller.js